<template>
  <a-spin :spinning="spinning">
    <a-form-model :colon="false" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" layout="inline">
      <a-space>
        <a-form-model-item :label="$t('business.label.packingPosition')+':'">
          <vxe-select v-model="position.id" :options="positions" placeholder="placeholder.packingPosition" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item v-if="device" :label="$t('business.label.turnoverBox')+':'">
          <vxe-input ref="containerNo" v-model="container.no" style="width: 100%" @keydown.native.enter="obtain"/>
        </a-form-model-item>
        <a-form-model-item v-if="!device" :label="$t('business.label.pickingOrder')+':'">
          <vxe-input ref="pickingOrderNo" v-model="pickingOrder.no" style="width: 100%" @keydown.native.enter="obtain"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.barcode')+':'">
          <vxe-input ref="itemBarcode" v-model="item" style="width: 100%" @keydown.native.enter="onItemScanned"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.reviewer')+'1:'">
          <vxe-input :editable="false" :value="operator.name" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.reviewer')+'2:'">
          <vxe-input v-model="reviewer2" style="width: 100%" @click="()=>$refs.employeeModal.open()"/>
          <employee-modal ref="employeeModal" @change="(user)=>reviewer2=user[0].name"/>
        </a-form-model-item>
      </a-space>
    </a-form-model>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table1"
      align="center"
      :data="data1"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclickTable1(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="lot.no" title="business.label.lot"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
      <vxe-column field="command.plannedQuantity" title="business.label.plannedQuantity"/>
      <vxe-column field="command.actualQuantity" title="business.label.actualQuantity"/>
      <vxe-column field="location.no" title="business.label.storageLocation"/>
      <vxe-column field="picking.operator" title="business.label.picker"/>
      <vxe-column field="packing.startTime" title="business.label.obtainTime" width="170"/>
    </vxe-table>
    <a-descriptions :column="5" bordered size="small" style="margin-top: 2px">
      <a-descriptions-item :label="$t('business.label.orderNo')">
        <span class="specialFont">{{view.order.no}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.pickupMode')">
        <span class="specialFont">{{view.pickupMode.name}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.customerNo')">
        <span class="specialFont">{{view.customer.no}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.customerName')" span="2">
        <a-tooltip :title="view.customer.name" class="specialFont">{{view.customer.name}}</a-tooltip>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.itemNo')">
        <span class="specialFont">{{view.item.no}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.itemName')">
        <a-tooltip ref="itemDesc" :title="view.item.name" class="specialFont">{{truncateString(view.item.name, 18)}}</a-tooltip>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.specification')">
        <a-tooltip :title="view.pack.specification" class="specialFont">{{truncateString(view.pack.specification, 18)}}</a-tooltip>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.uom')">
        <span class="specialFont">{{view.pack.uom}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.factor')">
        {{view.pack.factor}}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.lot')">
        <span class="specialFont">{{view.lot.no}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.productionDate')">
        {{view.lot.productionDate}}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.validUntil')">
        {{view.lot.validUntil}}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.manufacturer')">
        {{view.lot.manufacturer}}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.producingArea')">
        {{view.lot.producingArea}}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.appendageSign')">
        {{view.command.appendageSign ? appendageSigns.find(it => it.ordinal === view.command.appendageSign).name : ''}}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.plannedQuantity')">
        {{view.command.plannedQuantity}}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.actualQuantity')">
        <span class="specialFont">{{view.command.actualQuantity}}</span>
      </a-descriptions-item>
      <a-descriptions-item gutter="20" label="其它信息">
        <span v-if="view.command.supervised">
          <span class="specialFont">{{$t('business.label.supervised')}}</span>
        </span>
        <span v-else>
          <span class="ignoreFont">{{$t('business.label.supervised')}}</span>
        </span>
        <span v-if="view.item.fragile" style="margin-left: 10px">
          <span class="specialFont">{{$t('business.label.fragile')}}</span>
        </span>
        <span v-else style="margin-left: 10px">
          <span class="ignoreFont">{{$t('business.label.fragile')}}</span>
        </span>
      </a-descriptions-item>
    </a-descriptions>
    <vxe-table
      ref="table2"
      :data="data2"
      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
      :export-config="{}"
      :height="scrollY"
      :keyboard-config="{isArrow: true}"
      :loading="loading"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :scroll-x="{enabled: true}"
      align="center"
      border
      keep-source
      round
      show-header-overflow
      show-overflow
      size="mini"
      stripe
      style="margin-top: 2px"
      @cell-click="({row})=>clickTable2(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="barcode.no" title="business.label.groupage" width="100"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.no" title="business.label.lot"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
      <vxe-column field="lot.producingArea" title="business.label.producingArea"/>
      <vxe-column field="command.plannedQuantity" title="business.label.plannedQuantity"/>
      <vxe-column :edit-render="{autofocus: '.vxe-input--inner'}" field="command.actualQuantity" title="business.label.actualQuantity">
        <template #edit="{ row }">
          <vxe-input v-model="row.command.actualQuantity" :max="row.command.plannedQuantity" :min="0" align="center" placeholder="" type="number"/>
        </template>
      </vxe-column>
      <vxe-column :edit-render="{}" field="command.appendageSign" title="business.label.appendageSign">
        <template #default="{ row }">
          {{appendageSigns.find(it => it.ordinal === row.command.appendageSign).name}}
        </template>
        <template #edit="{ row }">
          <vxe-select v-model="row.command.appendageSign" align="center" transfer>
            <vxe-option v-for="item in appendageSigns" :key="item.ordinal" :label="item.name" :value="item.ordinal"/>
          </vxe-select>
        </template>
      </vxe-column>
    </vxe-table>
    <employee-modal ref="employeeModal" @change="(user)=>reviewer2=user[0].name"/>
    <supervised-modal ref="supervisedModal"/>
    <ShipmentBarcodeModal ref="shipmentBarcodeModal"/>
  </a-spin>
</template>
<script>
import moment from 'moment'
import { findAll, findEnum, post } from '@/api/Api'
import Api from '@/api'
import Vue from 'vue'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import EmployeeModal from '@/views/modal/UserModal.vue'
import SupervisedModal from '@/views/modal/SupervisedModal.vue'
import { ShippingFactoryView } from '@/api/dto/view/ShippingFactoryView'
import ShipmentBarcodeModal from '@/views/modal/ShipmentBarcodeModal.vue'
import { truncateString } from '@/utils/util'

export default {
  name: 'PackingTaskDetail',
  components: { ShipmentBarcodeModal, SupervisedModal, EmployeeModal },
  data() {
    return {
      data1: [],
      data2: [],
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      position: { id: null, no: '' },
      container: { id: null, no: '' },
      pickingOrder: { id: null, no: '' },
      item: '',
      reviewer2: '',
      view: new ShippingFactoryView(),
      appendageSigns: [],
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.3175),// 表格竖向滚动条
      spinning: false,
      descriptionWidth: 0
    }
  },
  props: {
    device: {
      type: Boolean,
      default: false
    },
    autoReview: {
      type: Boolean,
      default: false
    },
    entire: {
      type: Boolean,
      default: false
    },
    positionTypeId: {
      type: String,
      default: ''
    },
    positions: {
      type: Array,
      default: []
    }
  },
  mounted() {
    findEnum('AppendageSign').then(res => {
      this.appendageSigns = res.result
    })
  },
  methods: {
    truncateString,
    moment,
    check() {
      if (this.device) {
        if (this.container.no === '') {
          return this.$warning({
            title: '请输入周转箱号',
            centered: true,
            okText: '确定'
          })
        }
      } else {
        if (this.pickingOrder.no === '') {
          return this.$warning({
            title: '请输入拣货单号',
            centered: true,
            okText: '确定'
          })
        }
      }
    },
    refresh() {
      this.loading = true
      const args = {
        'container.no': this.device ? this.container.no : undefined,
        'pickingOrder.no': this.device ? undefined : this.pickingOrder.no,
        commandStatus: ['PACKING_OBTAINED', 'ITEM_REVIEWED']
      }
      findAll('packingTaskDetailFactory', args).then(res => {
        if (res.success) {
          if (res.result.length === 0) {
            this.reset()
            this.$nextTick(() => {
              this.device ? this.$refs.containerNo.focus() : this.$refs.pickingOrderNo.focus()
            })
          } else {
            this.data1 = res.result.filter(row => row.command.commandStatus === 36)
            this.data2 = res.result.filter(row => row.command.commandStatus === 37)
            if (this.data2.length > 0) {
              const item = this.data2[0]
              this.$refs.table2.setRadioRow(item)
              this.$refs.table2.setCurrentRow(item)
              this.clickTable2(item)
            }
          }
        }
      }).finally(() => this.loading = false)
    },
    onItemScanned() {
      if (this.item !== '') {
        const ids = this.data1.filter(row => row.item.no.includes(this.item) || row.item.mnemonicCode.includes(this.item) || row.item.barcodes.includes(this.item)).map(row => row.command.id)
        if (ids.length === 0) {
          this.$message.warning('未找到条码对应的任务')
        }
        this.review(ids)
      }
      this.item = ''
      this.$nextTick(() => {
        this.$refs.itemBarcode.focus()
      })
    },
    dblclickTable1(row) {
      this.review([row.command.id])
    },
    clickTable2(row) {
      Object.assign(this.view, row)
    },
    obtain() {
      this.check()
      this.spinning = true
      const args = {
        'position.id': this.position.id,
        'container.no': this.device ? this.container.no : undefined,
        'pickingOrder.no': this.device ? undefined : this.pickingOrder.no,
        entire: this.entire
      }
      post(Api.packingObtain, { type: this.device ? 'containerObtainer' : 'pickingOrderObtainer' }, args).then(res => {
        if (res.success) {
          this.refresh()
        } else {
          this.reset()
        }
      }).finally(() => this.spinning = false)
    },
    review(ids) {
      this.spinning = true
      post(Api.packingObtain, { type: 'commandObtainer' }, { ids: ids }).then(res => {
        if (res.success) {
          this.refresh()
        }
      }).finally(() => this.spinning = false)
    },
    reset() {
      this.data1 = []
      this.data2 = []
      this.position = { id: null, no: '' }
      this.container = { id: null, no: '' }
      this.pickingOrder = { id: null, no: '' }
      this.item = ''
      this.reviewer2 = ''
      this.view = new ShippingFactoryView()
    },
    sealing() {
      const row = this.data2.find(row => row.barcode === null || row.barcode.id === null)
      if (!row) {
        this.$message.warning('没有可以封箱的数据')
        return
      }
      this.spinning = true
      post(Api.packingSealing, {}, { 'command.id': row.command.id, autoReview: this.autoReview, reviewer: this.reviewer2 }).then(res => {
        if (res.success) {
          this.$message.success('封箱完成')
          this.refresh()
        }
      }).finally(() => this.spinning = false)
    },
    confirm() {
      this.check()
      this.spinning = true
      const args = {
        'container.no': this.device ? this.container.no : undefined,
        'pickingOrder.no': this.device ? undefined : this.pickingOrder.no,
        reviewer: this.reviewer2
      }
      post(Api.packingConfirm, { type: this.device ? 'containerConfirmer' : 'pickingOrderConfirmer' }, args).then(res => {
        if (res.success) {
          this.reset()
        }
      }).finally(() => this.spinning = false)
    },
    split() {
      const currentRow = this.$refs.table1.getCurrentRecord()
      if (currentRow === null) {
        return this.$warning({
          title: '请先选择需要拆分的任务',
          centered: true,
          okText: '确定'
        })
      }
      this.spinning = true
      post(Api.packingSplit, {}, { id: currentRow.command.id, actualQuantity: currentRow.command.actualQuantity }).then(res => {
        if (res.success) {
          this.refresh()
        }
      }).finally(() => this.spinning = false)
    },
    save() {
      const currentRow = this.$refs.table2.getCurrentRecord()
      if (currentRow === null) {
        return this.$warning({
          title: '请先选择需要短拣的任务',
          centered: true,
          okText: '确定'
        })
      }
      this.spinning = true
      const args = {
        id: currentRow.command.id,
        actualQuantity: currentRow.command.actualQuantity,
        appendageSign: currentRow.command.appendageSign
      }
      post(Api.packingCount, {}, args).then(res => {
        if (res.success) {
          this.refresh()
        }
      }).finally(() => this.spinning = false)
    },
    openSupervisedModal() {
      this.check()
      const args = {
        'container.no': this.device ? this.container.no : undefined,
        'pickingOrder.no': this.device ? undefined : this.pickingOrder.no,
        commandStatusRange: { start: 'PACKING_OBTAINED', end: 'ITEM_REVIEWED' }
      }
      this.$refs.supervisedModal.open(args)
    },
    openShipmentBarcodeModal() {
      this.$refs.shipmentBarcodeModal.open()
    }
  }
}
</script>
<style scoped>
.specialFont {
  font-weight: bold;
  color: red;
}

.ignoreFont {
  font-weight: bold;
  color: #837D7DFF;
}

</style>